/** Corporate formation & company-secretarial Q&A (deterministic, source-led). */
import { CORPORATE_SERVICES, CORPORATE_NATIONALITIES, CORPORATE_ZONES } from "./index";
import { asOf, buildQA, matrixQA, phrasingCount, serviceQA, type BusinessQA } from "../_qa/business-generator";

export const CORPORATE_REVIEWED_TH = "สิงหาคม 2569";
export const CORPORATE_REVIEWED_ISO = "2026-08-06T00:00:00.000Z";

const VOLATILE =
  "หลักเกณฑ์ แบบฟอร์ม ค่าธรรมเนียม และช่องทางยื่นอาจเปลี่ยนตามประกาศของกรมพัฒนาธุรกิจการค้า กรมสรรพากร BOI หรือหน่วยงานอนุญาตเฉพาะทาง ควรตรวจประกาศล่าสุดที่ dbd.go.th, rd.go.th และ boi.go.th ก่อนยื่น";
const A = asOf(CORPORATE_REVIEWED_TH, VOLATILE);

const CORE: BusinessQA[] = [
  {
    slug: "corporate-foreign-ownership-basics",
    q: "ชาวต่างชาติถือหุ้นบริษัทไทยได้กี่เปอร์เซ็นต์",
    a: `หลักทั่วไปตามพระราชบัญญัติการประกอบธุรกิจของคนต่างด้าว พ.ศ. 2542 คือธุรกิจในบัญชีแนบท้ายถูกจำกัดสิทธิของคนต่างด้าว หากถือหุ้นตั้งแต่กึ่งหนึ่งขึ้นไปและประกอบธุรกิจที่ถูกจำกัด ต้องพิจารณาขอใบอนุญาตประกอบธุรกิจของคนต่างด้าว สิทธิตามสนธิสัญญา หรือการส่งเสริมการลงทุนจาก BOI แล้วแต่กรณี การใช้ผู้ถือหุ้นไทยแทนโดยไม่ลงทุนจริงเป็นความเสี่ยงทางกฎหมายที่ไม่ควรทำ ${A}`,
    synonyms: ["ต่างชาติถือหุ้นบริษัทไทย", "foreign ownership Thai company limit"],
  },
  {
    slug: "corporate-min-capital-foreign",
    q: "บริษัทที่มีคนต่างชาติร่วมทุนต้องมีทุนจดทะเบียนเท่าไร",
    a: `ทุนจดทะเบียนที่เหมาะสมขึ้นกับสิ่งที่จะใช้สิทธิต่อ เช่น การขอใบอนุญาตประกอบธุรกิจของคนต่างด้าว การขอใบอนุญาตทำงานสำหรับพนักงานต่างชาติ หรือเงื่อนไขของโครงการ BOI ซึ่งแต่ละกรณีมีเกณฑ์ทุนและอัตราส่วนพนักงานต่างกัน ควรกำหนดทุนจากแผนธุรกิจและเงื่อนไขที่จะใช้จริง ไม่ใช่ตั้งตัวเลขไว้ก่อนแล้วแก้ภายหลัง ${A}`,
    synonyms: ["ทุนจดทะเบียนขั้นต่ำต่างชาติ", "minimum registered capital work permit Thailand"],
  },
  {
    slug: "corporate-vat-registration-trigger",
    q: "บริษัทต้องจดทะเบียนภาษีมูลค่าเพิ่มเมื่อใด",
    a: `ผู้ประกอบการที่มีรายรับจากการขายสินค้าหรือให้บริการถึงเกณฑ์ที่ประมวลรัษฎากรกำหนดต้องยื่นจดทะเบียนภาษีมูลค่าเพิ่มภายในกำหนดเวลา นอกจากนี้ธุรกิจบางประเภทหรือการใช้สิทธิบางอย่างอาจต้องจด VAT ตั้งแต่เริ่มดำเนินการ ควรตรวจเกณฑ์รายรับและกำหนดเวลาปัจจุบันที่ rd.go.th และเก็บหลักฐานรายรับให้ตรวจสอบย้อนหลังได้ ${A}`,
    synonyms: ["จด VAT เมื่อไหร่", "VAT registration threshold Thailand"],
  },
  {
    slug: "corporate-annual-obligations",
    q: "บริษัทจำกัดมีหน้าที่ประจำปีอะไรที่ห้ามลืม",
    a: `หน้าที่หลักคือจัดทำบัญชีและงบการเงินที่ผู้สอบบัญชีรับอนุญาตตรวจสอบ จัดประชุมผู้ถือหุ้นสามัญประจำปี นำส่งงบการเงินและบัญชีรายชื่อผู้ถือหุ้นต่อกรมพัฒนาธุรกิจการค้า และยื่นแบบภาษีตามรอบที่ประมวลรัษฎากรกำหนด กำหนดเวลาแต่ละรายการต่างกันและมีค่าปรับหากล่าช้า ควรทำปฏิทินหน้าที่รายปีไว้ตั้งแต่ต้นปีบัญชี ${A}`,
    synonyms: ["หน้าที่ประจำปีบริษัท", "annual compliance Thai company"],
  },
  {
    slug: "corporate-director-liability",
    q: "กรรมการบริษัทมีความรับผิดอย่างไรถ้าบริษัททำผิด",
    a: `กรรมการมีหน้าที่ดำเนินกิจการด้วยความระมัดระวังตามประมวลกฎหมายแพ่งและพาณิชย์และกฎหมายเฉพาะ หากละเว้นหน้าที่หรือมีส่วนในการกระทำผิด อาจมีความรับผิดทางแพ่ง ทางปกครอง หรือทางอาญาตามที่กฎหมายนั้นกำหนด การเป็นกรรมการในนามโดยไม่ควบคุมการดำเนินงานจริงจึงมีความเสี่ยงสูง ควรมีระบบอนุมัติและเก็บมติเป็นลายลักษณ์อักษร ${A}`,
    synonyms: ["ความรับผิดกรรมการ", "director liability Thailand"],
  },
  {
    slug: "corporate-documents-legalisation",
    q: "เอกสารบริษัทแม่ต่างประเทศที่ใช้จดทะเบียนในไทยต้องรับรองอย่างไร",
    a: `ต้องมีคำแปลที่ถูกต้องและผ่านการรับรองตามที่หน่วยงานผู้พิจารณากำหนด โดยหลายกรณีต้องผ่านการรับรองจากหน่วยงานต้นทางและกรมการกงสุล ค่าธรรมเนียมนิติกรณ์ที่กรมการกงสุลประกาศคือ 200 บาทต่อตราประทับสำหรับบริการปกติ และ 400 บาทต่อตราประทับสำหรับบริการด่วน เมื่ออนุสัญญา Apostille มีผลกับประเทศไทยวันที่ 28 กุมภาพันธ์ 2570 เอกสารจากประเทศภาคีอาจใช้ Apostille แทนการรับรองหลายชั้นได้ ${A}`,
    synonyms: ["รับรองเอกสารบริษัทแม่", "legalisation parent company documents Thailand"],
  },
];

const CTX = { asOf: A, authority: "หน่วยงานทะเบียนและหน่วยงานอนุญาตที่เกี่ยวข้อง", clusterTh: "งานจดทะเบียนและงานเลขานุการบริษัท" };

export const CORPORATE_QA_ALL: BusinessQA[] = buildQA([
  CORE,
  CORPORATE_SERVICES.flatMap((s) => serviceQA(s, CTX)),
  matrixQA(CORPORATE_SERVICES, CORPORATE_NATIONALITIES.map((n) => ({ slug: n.slug, nameTh: n.nameTh, nameEn: n.nameEn, note: n.notes })), { asOf: A, authority: CTX.authority, axisLabelTh: "กลุ่มนักลงทุนสัญชาติ" }),
  matrixQA(CORPORATE_SERVICES, CORPORATE_ZONES.map((z) => ({ slug: z.slug, nameTh: z.nameTh, nameEn: z.nameEn, note: z.highlights })), { asOf: A, authority: CTX.authority, axisLabelTh: "ย่านธุรกิจ" }),
]);

export const CORPORATE_QA_BY_SLUG: Record<string, BusinessQA> = Object.fromEntries(
  CORPORATE_QA_ALL.map((x) => [x.slug, x]),
);

export const CORPORATE_QA_PHRASING_COUNT = phrasingCount(CORPORATE_QA_ALL);
